import { CarrierDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { Snackbar } from '../../../ui/components/pure/snackbar/snackbar.component';
import { AddNoteActionModal } from '../../../ui/components/higher-order/add-note-action/add-note-modal.component';
import { KnownNoteEntityTypes } from '../../../ui/components/higher-order/add-note-action/add-note.hook';
import { CarrierDetailsActions } from './actions/carrier-details.actions';
import { EditCarrierModal } from './actions/edit-carrier/edit-carrier-action.component';
import { EditPoliciesModal } from './actions/edit-policies/edit-policies-action.component';
import { ApproveCarrierModal } from '../actions/approve-carrier.modal';
import { DeleteCarrierModal } from '../actions/delete-carrier.modal';
import { AssignNetworksModal } from '../assign-networks-modal/assign-networks.modal';
import { CreateCourierModal } from '../../couriers/list/actions/add-courier/add-courier-action.component';

export type CarrierActions = {
  currentAction: CarrierDetailsActions | null;
  setAction: (action: CarrierDetailsActions | null) => void;
};

export function CarrierDetailsActionsObserver({
  actions,
  carrier,
  projectID,
  onDeleted
}: {
  actions: CarrierActions;
  carrier: CarrierDto;
  projectID: string;
  onDeleted(): void;
}) {
  switch (actions.currentAction) {
    case CarrierDetailsActions.EDIT_CARRIER:
      return (
        <EditCarrierModal
          carrier={carrier}
          onSuccess={() => actions.setAction(CarrierDetailsActions.EDIT_SUCCESS)}
          onAbort={() => actions.setAction(null)}
        />
      );
    case CarrierDetailsActions.EDIT_POLICIES:
      return (
        <EditPoliciesModal
          carrier={carrier}
          onSuccess={() => actions.setAction(CarrierDetailsActions.EDIT_SUCCESS)}
          onAbort={() => actions.setAction(null)}
        />
      );
    case CarrierDetailsActions.ASSIGN_NETWORKS:
      return (
        <AssignNetworksModal
          groupID={carrier.id}
          carrierName={carrier.name}
          description={`Where ${carrier.name} may work.`}
          onSuccess={() => actions.setAction(CarrierDetailsActions.EDIT_SUCCESS)}
          onCancel={() => actions.setAction(null)}
        />
      );
    case CarrierDetailsActions.EDIT_SUCCESS:
      return (
        <Snackbar severity="success" onClose={() => actions.setAction(null)}>
          Carrier updated
        </Snackbar>
      );
    case CarrierDetailsActions.APPROVE_CARRIER:
      return (
        <ApproveCarrierModal
          carrier={carrier}
          onSuccess={() => actions.setAction(CarrierDetailsActions.APPROVE_SUCCESS)}
          onCancel={() => actions.setAction(null)}
        />
      );
    case CarrierDetailsActions.APPROVE_SUCCESS:
      return (
        <Snackbar severity="success" onClose={() => actions.setAction(null)}>
          Carrier approved
        </Snackbar>
      );
    case CarrierDetailsActions.DELETE_CARRIER:
      return <DeleteCarrierModal carrier={carrier} onSuccess={onDeleted} onCancel={() => actions.setAction(null)} />;
    case CarrierDetailsActions.ADD_NOTE:
      return (
        <AddNoteActionModal
          id={carrier.id}
          projectID={projectID}
          onSuccess={() => actions.setAction(CarrierDetailsActions.ADD_NOTE_SUCCESS)}
          onAbort={() => actions.setAction(null)}
          entityType={KnownNoteEntityTypes.Group}
        />
      );
    case CarrierDetailsActions.ADD_COURIER:
      return (
        <CreateCourierModal
          projectID={projectID}
          carrier={carrier}
          onSuccess={() => actions.setAction(CarrierDetailsActions.ADD_COURIER_SUCCESS)}
          onAbort={() => actions.setAction(null)}
        />
      );
    case CarrierDetailsActions.ADD_COURIER_SUCCESS:
      return (
        <Snackbar severity="success" onClose={() => actions.setAction(null)}>
          The courier has been created
        </Snackbar>
      );
    case CarrierDetailsActions.ADD_NOTE_SUCCESS:
      return (
        <Snackbar severity="success" onClose={() => actions.setAction(null)}>
          Note added
        </Snackbar>
      );
    default:
      return null;
  }
}
